import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Link } from "react-router-dom";
function Item () { 

    // Countdown
  const [day1, setDay1] = useState(0);
  const [day2, setDay2] = useState(0);

  const [hour1, setHour1] = useState(0);
  const [hour2, setHour2] = useState(0);
  const [hour3, setHour3] = useState(0);

  const [minute1, setMinute1] = useState(0);
  const [minute2, setMinute2] = useState(0);

  const [second1, setSecond1] = useState(0);
  const [second2, setSecond2] = useState(0);

  // Timer
  const countDown = () => {
    const dueDate = new Date("Feb 28, 2022 00:00").getTime();
    const currentDate = new Date().getTime();

    const remainings = dueDate - currentDate;

    if (remainings > 0) {
      let second = 1000;
      let minute = second * 60;
      let hour = minute * 60;
      let day = hour * 24;

      // Remainings
      let remainingDay = Math.floor(remainings / day);
      let remainingHour = Math.floor((remainings % day) / hour);
      let remainingMinute = Math.floor((remainings % hour) / minute);
      let remainingSecond = Math.floor((remainings % minute) / second);

      // Day
      let dayLength = remainingDay.toString().length;

      if (dayLength === 1) {
        setDay1(0);
        setDay2(remainingDay);
      } else if (dayLength === 2) {
        remainingDay = remainingDay.toString().split("");

        setDay1(remainingDay[0]);
        setDay2(remainingDay[1]);
      }

      // Hour
      let hourLength = remainingHour.toString().length;

      if (hourLength === 1) {
        setHour1(0);
        setHour2(remainingHour);
      } else if (hourLength === 2) {
        remainingHour = remainingHour.toString().split("");

        setHour1(remainingHour[0]);
        setHour2(remainingHour[1]);
      }

      // Minute
      let minuteLength = remainingMinute.toString().length;

      if (minuteLength === 1) {
        setMinute1(0);
        setMinute2(remainingMinute);
      } else if (minuteLength === 2) {
        remainingMinute = remainingMinute.toString().split("");

        setMinute1(remainingMinute[0]);
        setMinute2(remainingMinute[1]);
      }

      // Second
      let secondLength = remainingSecond.toString().length;

      if (secondLength === 1) {
        setSecond1(0);
        setSecond2(remainingSecond);
      } else if (secondLength === 2) {
        remainingSecond = remainingSecond.toString().split("");

        setSecond1(remainingSecond[0]);
        setSecond2(remainingSecond[1]);
      }
    } else {
      setDay1(0);
      setDay2(0);

      setHour1(0);
      setHour2(0);

      setMinute1(0);
      setMinute2(0);

      setSecond1(0);
      setSecond2(0);
    }
  };

  setInterval(countDown, 1000);
     return (
<>
    {/*
    <!-- =============page banner==================== -->*/}
    <div className="page-banner">
        <div className="container">
            <div className="page-banner-content">
                <div className="banner-inner">
                    <h2>About</h2>
                    <div className="page-route">
                        <a href="">Home </a>
                        <p> / About </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/*
    <!-- =============page banner end================ -->*/} 
    {/* <!-- ============feature============== --> */}
    <section>
        <div className="feature-sec cpt-6">
            <div className="container">
                <div className="row align-item-center">

                    <div className="col-xl-6 col-lg-6 mb-4">
                        <div className="about-img">
                            <img src="assets/img/inner/13.png" alt=""/>

                            <div className="favorite">
                                <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 mb-4">
                        <div className="about-right-content">
                            <div className="feature-content">
                                <h1 className="sec-title">
                                “The Fantasy Flower illustration ”
                                </h1>
                                <div className="view-qu-share">
                                    <div className="count">
                                        <p className="view"><i className="icofont-eye"></i>225</p>
                                        <p className="view"><i className="icofont-heart"></i>100</p>
                                    </div>
                                   <div className="share-area">
                                        <p className="share-btn"><i className="icofont-share"></i></p>
                                        <p className="share-btn"><i className="icofont-listine-dots"></i></p>
                                   </div>

                                </div>

                                <div className="owned-creator">
                                    <div className="on-card my-3">
                                        <div className="row">
                                            <div className="col-sm-6 mmb-3">
                                                <div className="author-info">
                                                    <img src="assets/img/inner/7.jpg" alt="" className="author-img"/>
                                                    <div className="author-name-type">
                                                        <p className="author-type">Owned By</p>
                                                        <a href="" className="creator-profile">Ralph Garraway</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="author-info">
                                                    <img src="assets/img/inner/8.jpg" alt="" className="author-img"/>
                                                    <div className="author-name-type">
                                                        <p className="author-type">Create By</p>
                                                        <a href="" className="creator-profile">Freddie Carpenter</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <p className="feature-des">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed doeiusmod tempor incididunt ut labore et dolore magna aliuis ipsum suspendisse ultrices gravida. Risus commodo It is a long established fact that a reader will be distracted by the readable
                                    content of a page when looking
                                </p>

                                <div className="row">
                                    <div className="col-xxl-6 col-sm-12">
                                        <div className="sale-count">
                                            <div className="inner-text">
                                                <p>Current Bid</p>
                                                <div className="price-count"> <h5>499 editions</h5> <span>= $12.246</span></div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-xxl-6 col-sm-12">
                                        <div className="sale-count">
                                            <div className="inner-text">
                                                <p> <span>Countdown</span></p>
                                                <div className="end-timer">
                                                    <img src="assets/img/icon/fire.svg" alt="" />
                                                    <div className="count-part">
                                                        <span>{day1}</span>
                                                        <span>{day2}</span>
                                                    </div>
                                                    <span>:</span>
                                                    <div className="count-part">
                                                        <span>{hour1}</span>
                                                        <span>{hour2}</span>
                                                    </div>
                                                    <span>:</span>
                                                    <div className="count-part">
                                                        <span>{minute1}</span>
                                                        <span>{minute2}</span>
                                                    </div>
                                                    <span>:</span>
                                                    <div className="count-part">
                                                        <span>{second1}</span>
                                                        <span>{second2}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a href="" className="custom-btn w-100"><span>GET A QUOTE </span></a>



                                <ul className="nav nav-pills mb-3 tab-head mt-4" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="tab-btn active" id="pills-owners-tab" data-bs-toggle="pill" data-bs-target="#pills-owners" type="button" role="tab" aria-controls="pills-owners" aria-selected="true">Owners</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="tab-btn" id="pills-bids-tab" data-bs-toggle="pill" data-bs-target="#pills-bids" type="button" role="tab" aria-controls="pills-bids" aria-selected="false">Bids</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="tab-btn" id="pills-history-tab" data-bs-toggle="pill" data-bs-target="#pills-history" type="button" role="tab" aria-controls="pills-history" aria-selected="false">History</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-owners" role="tabpanel" aria-labelledby="pills-owners-tab">
                                        <div className="row">
                                            <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="pills-bids" role="tabpanel" aria-labelledby="pills-bids-tab">
                                        <div className="row">
                                        <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="pills-history" role="tabpanel" aria-labelledby="pills-history-tab">
                                        <div className="row">
                                        <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mb-3">
                                                <div className="bid-author">
                                                    <div className="author">
                                                        <div className=" profile-img">
                                                            <img src="assets/img/inner/15.png" alt="Image not found"/>
                                                            <div className="mark"><i className="icofont-tick-mark"></i></div>
                                                        </div>
                                                        <div className="author-details">
                                                            <a href="" className="author-link">Psychedelics Anon <span>place a bid</span></a>
                                                            <p>8 hours ago</p>
                                                        </div>
                                                    </div>
                                                    <div className="buy-rate">
                                                        <p className="price-bid">4.89 ETH </p>
                                                        <span>= $12.246</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    {/* <!-- ============feature end============== --> */}
{/* // ==============expolor product============= */}
<div className="expolor-product cpy-6">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Explore Products</h2>
                            <a href="" className="see-more-btn">Explore more</a>
                        </div>
                    </div>
                    <div className="row">
                    <div className="service-boxes">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                        slidesPerView: 1.4,
                                      },
                                      680: {
                                        slidesPerView: 2,
                                      },
                                    1050: {
                                      slidesPerView: 3,
                                    },
                                    1400: {
                                        slidesPerView: 4,
                                      },
                                    
                                  }}
                                >
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/2.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/3.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/4.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/10.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/5.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/6.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/12.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
						</div>
                    </div>
                </div>
            </div>
            {/* // ==============expolor product============= */}
    </> 
    ); 
} 
    
export default Item;